import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Landing from "./views/Landing.vue";
import WhatWeTeach from "./views/WhatWeTeach.vue";
import OurMinistries from "./views/OurMinistries.vue";
import OurLeaders from "./views/OurLeaders.vue";
import ChurchPlanting from "./views/ChurchPlanting.vue";
import Affiliates from "./views/Affiliates.vue";
import Giving from "./views/Giving.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/what-we-teach",
      name: "what-we-teach",
      components: {
        header: AppHeader,
        default: WhatWeTeach,
        footer: AppFooter
      },
    },
    {
      path: "/our-ministries",
      name: "our-ministries",
      components: {
        header: AppHeader,
        default: OurMinistries,
        footer: AppFooter
      }
    },
    {
      path: "/our-leaders",
      name: "our-leaders",
      components: {
        header: AppHeader,
        default: OurLeaders,
        footer: AppFooter
      }
    },
    {
      path: "/church-planting",
      name: "church-planting",
      components: {
        header: AppHeader,
        default: ChurchPlanting,
        footer: AppFooter
      }
    },
    {
      path: "/affiliates",
      name: "affiliates",
      components: {
        header: AppHeader,
        default: Affiliates,
        footer: AppFooter
      }
    },
    {
      path: "/giving",
      name: "giving",
      components: {
        header: AppHeader,
        default: Giving,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
